import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ProductsService from "@services/ProductsService";

export const createProduct = createAsyncThunk(
  "product/create",
  async ({product}, {rejectWithValue}) => {
    try {
      await ProductsService.createProduct({product});
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const current = {
  name: "",
  country: "",
  product_line: "",
  country_id: null,
  product_line_id: null,
  mask: "",
  product_version: {
    questions: "",
  },
};

const initialState = {
  target: current,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createProductSlice = createSlice({
  name: "create-product",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearCreate() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(createProduct.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createProduct.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, setError, setStatus, clearCreate} =
  createProductSlice.actions;
export default createProductSlice.reducer;
